import '../scss/spec-page-style.scss';
import SpecPage from './pages/blog/spec/index';

document.addEventListener('DOMContentLoaded', () => {
  SpecPage.init();
});
